import React from 'react';
import styled from 'styled-components';
import { SelectedDocuments } from '@features/document/SelectedDocuments';
import { SkeletonButton } from '@ui/buttons/SkeletonButton';
import { TransparentFlatButton } from '@ui/buttons';
import { DocumentSelectionModal } from '@features/document/DocumentSelectionModal/index';
import { FormStateContext } from '@/contexts/FormStateContext';

const SelectedDocumentsWrapper = styled.div`
  max-height: 200px;
  min-height: 42px;
  overflow-y: auto;
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-radius: 4px;
  padding: 8px;
`;
const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  padding-top: 16px;
`;

export const Sources = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { state: formState, setFormStateValue } = React.useContext(FormStateContext);
  const { selectedDocs: value } = formState;

  const onChange = (value) => {
    setFormStateValue('selectedDocs', value);
  };

  const onRemoveDocument = (document) => {
    onChange(value.filter((d) => d.id !== document.id));
  };

  const onRemoveAll = () => {
    onChange([]);
  };

  return (
    <div>
      {isModalOpen && <DocumentSelectionModal onDismiss={() => setIsModalOpen(false)} />}
      {value.length > 0 && (
        <SelectedDocumentsWrapper>
          <SelectedDocuments value={value} onRemoveDocument={onRemoveDocument} />
        </SelectedDocumentsWrapper>
      )}
      <ActionsWrapper>
        <SkeletonButton onClick={() => setIsModalOpen(true)}>Select Source Documents</SkeletonButton>
        {value.length > 0 && <TransparentFlatButton onClick={onRemoveAll}>Remove All</TransparentFlatButton>}
      </ActionsWrapper>
    </div>
  );
};
